export default {
  priv: 'manage',
  overviewTitle: 'Type Templates',
  detailTitle: 'Type Template',
  deleteTitle: 'deze Type Template',
  url: '/tc/sitetypes',
  apiUrl: '/sitetypetemplates/',
  sortBy: ['sitetype_id'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'tc/sitetypes',
  quickFilter: {
    text: 'Zoek op sitetype_id',
    value: 'sitetype_id',
    type: 'text'
  },
  newRecord: {
    resolution: 1
  },
  // isReadOnlyOverview: true,
  // customEditable(context, item) {
  //   return false;
  // },
  // customDeletable(context, item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Type', value: 'bd_sitetype_desc', link: '/tc/sitetypes/{id}', width: '10%'},
    {text: 'Resolutie', value: 'resolution', width: '10%'},
    {text: 'Dossier Template', value: 'dossier_template', width: '10%', type: 'filename'}
  ]
};
